// extracted by mini-css-extract-plugin
export default {"phn":"PhoneNumber_phn__7FHEp"};